import { REDUCER_KEY } from "./preference.constants";
export var getPreferences = function (state) {
    return state[REDUCER_KEY].preferences.items || [];
};
export var isFetchingPreferences = function (state, key) { return state[REDUCER_KEY].preferences.isFetching; };
export var fetchPreferenceError = function (state, key) { return state[REDUCER_KEY].preferences.fetchError; };
export var isCreatingPreference = function (state, key) { return state[REDUCER_KEY].preferences.isCreating; };
export var createPreferenceError = function (state, key) { return state[REDUCER_KEY].preferences.createError; };
export var isUpdatingPreference = function (state, key) { return state[REDUCER_KEY].preferences.isUpdating; };
export var updatePreferenceError = function (state, key) { return state[REDUCER_KEY].preferences.updateError; };
